import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { creaLabelNumeroEAnno, ElenchiManager, BaseContenutoConProgress, BaseGridLayout } from '@lucan/base-ui'
import { creaLabelPrefisso } from '@lucan/base-ui-jconnet'
import { OPERAZIONI } from 'configuration/ConfigurazioneApi'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import { CHIAVI_ROUTES } from 'configuration/ConfigurazioneRotte'
import Sezione from 'components/ui/Sezione'
import Titolo from 'components/ui/Titolo'
import BottoneIndietro from 'components/ui/BottoneIndietro'
import { useRichiestaServerLogged } from 'hook/useRichiestaServerLogged'
import useNavigate from 'utils/useNavigate'
import PassContenitore from '../PassContenitore'
import PassDettagliTarghe from './PassDettagliTarghe'
import PassDettagliAnagrafica from './PassDettagliAnagrafica'
import PassDettagliPermesso from './PassDettagliPermesso'

export default function PassDettagli() {
  const { inviaOperazione } = useRichiestaServerLogged()

  return (
    <PassContenitore>
      <ElenchiManager
        elenchi={[
          ELENCHI.PASS_PREFISSI,
          ELENCHI.PASS_TIPOLOGIE,
          ELENCHI.PASS_VARCHI,
          ELENCHI.PASS_ZONE_SOSTA,
        ]}
        render={el =>
          <PassDettagliInterno
            optionsPrefissi={el(ELENCHI.PASS_PREFISSI)}
            optionsTipologie={el(ELENCHI.PASS_TIPOLOGIE)}
            optionsVarchi={el(ELENCHI.PASS_VARCHI)}
            optionsZoneSosta={el(ELENCHI.PASS_ZONE_SOSTA)}
          />
        }
        opzioniGetElenco={{ inviaOperazione }}
      />
    </PassContenitore>
  )
}



function PassDettagliInterno(props) {
  const { optionsPrefissi } = props

  const { uuid } = useParams()

  const [permesso, setPermesso] = useState(null)
  const [refresh, setRefresh] = useState(Date.now())

  const {
    ScatolaMessaggi,
    inviaOperazione,
    inAttesaDelServer
  } = useRichiestaServerLogged()

  useEffect(() => {
    async function fetchPermesso() {
      const { ok, data } = await inviaOperazione(OPERAZIONI.PASS_GET, null, {}, {
        params: { uuidPermesso: uuid }
      })
      if (ok && data.esito) setPermesso(data.data)
    }
    fetchPermesso()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uuid, refresh])

  const { navigate } = useNavigate()

  function tornaAllaLista() {
    navigate(CHIAVI_ROUTES.PASS_LISTA)
  }

  function forzaFetchPermesso() {
    setRefresh(Date.now())
  }

  return (
    <>
      {ScatolaMessaggi}

      <BottoneIndietro
        testo='Torna alla lista'
        onClick={tornaAllaLista}
      />

      <BaseContenutoConProgress inAttesa={inAttesaDelServer}>
        {permesso &&
          <BaseGridLayout vertical noWrap spacing={3} sx={{ mb: 3 }}>
            <Titolo noMargine>
              Permesso&nbsp;
              {creaLabelPrefisso(permesso.datiGenerali.prefissoId, optionsPrefissi)}&nbsp;
              {creaLabelNumeroEAnno(permesso.datiGenerali.numero, permesso.datiGenerali.anno)}
            </Titolo>

            <Sezione>
              <PassDettagliPermesso permesso={permesso} {...props} />
            </Sezione>

            <Sezione>
              <PassDettagliAnagrafica permesso={permesso} {...props} />
            </Sezione>

            <Sezione>
              <PassDettagliTarghe
                permesso={permesso}
                forzaFetchPermesso={forzaFetchPermesso}
                {...props}
              />
            </Sezione>
          </BaseGridLayout>
        }
      </BaseContenutoConProgress>
    </>
  )
}